import { render, staticRenderFns } from "./HouseholdIncomeInput.vue?vue&type=template&id=119d72e9&scoped=true"
import script from "./HouseholdIncomeInput.vue?vue&type=script&lang=ts"
export * from "./HouseholdIncomeInput.vue?vue&type=script&lang=ts"
import style0 from "./HouseholdIncomeInput.vue?vue&type=style&index=0&id=119d72e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119d72e9",
  null
  
)

export default component.exports